(function(){
  var r = document.getElementById('k-conv-pdp');
  if (!r) return;
  var a = document.querySelector('#ProductSection .grid.product-single');
  if (a) a.parentNode.insertBefore(r, a);
  var title = r.getAttribute('data-k-display-title');
  var h1 = document.querySelector('#ProductSection .product-single__title');
  if (title && h1) h1.textContent = title;
  var desc = document.querySelector('#ProductSection .product-single__description');
  if (desc) {
    desc.innerHTML = '<ul class="k-bullets">' +
      '<li>Stronger heavy-duty clip - hang cleats, shoes, boots, or gear</li>' +
      '<li>Quad-stitched strap for less bounce on the go</li>' +
      '<li>Designed in the USA | 1-year warranty</li>' +
      '<li>Multiple colors | mix &amp; match | free shipping on every order</li>' +
      '</ul>';
  }

  // "Coming soon" colors (e.g. Pink while DRAFT): enable only if the storefront serves the product.
  r.querySelectorAll('[data-k-soon-handle]').forEach(function(sp){
    var h = sp.getAttribute('data-k-soon-handle');
    if (!h || !window.fetch) return;
    fetch('/products/' + h + '.js', {credentials:'same-origin', headers:{'Accept':'application/json'}})
      .then(function(res){ return res.ok ? res.json() : null; })
      .then(function(p){
        if (!p || !p.available) return;
        var a = document.createElement('a');
        a.className = 'k-swatch';
        a.setAttribute('data-color', sp.getAttribute('data-color'));
        a.href = '/products/' + h;
        var lbl = (sp.getAttribute('title') || '').replace(/\s*—.*$/, '');
        a.title = lbl; a.setAttribute('aria-label', lbl);
        sp.parentNode.replaceChild(a, sp);
      })
      .catch(function(){});
  });

  var onSingle = r.getAttribute('data-k-on-single') === '1';
  var stickyLabel = r.querySelector('[data-k-sticky-label]');
  var stickyBtn = r.querySelector('[data-k-sticky-button]');
  var selectedQty = 1;

  function qtyInput(){
    return document.querySelector('#Quantity, input[name="quantity"], #ProductSection input[name="quantity"]');
  }

  function ensureQtyInput(){
    var form = document.querySelector('#AddToCartForm, form[action*="/cart/add"], #ProductSection form');
    if (!form) return null;
    var inp = form.querySelector('input[name="quantity"]');
    if (!inp) {
      inp = document.createElement('input');
      inp.type = 'hidden';
      inp.name = 'quantity';
      inp.id = 'Quantity';
      form.appendChild(inp);
    }
    return inp;
  }

  function packLabel(q){
    if (q === 3) return '3 Pack | $49.99';
    if (q === 5) return '5 Pack | $59.99';
    return '1 Clip | $19.99';
  }

  function atcLabel(q){
    if (q === 3) return 'Add to cart - 3 Pack';
    if (q === 5) return 'Add to cart - 5 Pack';
    return 'Add to cart - 1 Clip';
  }

  function setQty(q){
    selectedQty = q;
    var inp = ensureQtyInput() || qtyInput();
    if (inp) {
      inp.value = String(q);
      try {
        inp.dispatchEvent(new Event('change', {bubbles:true}));
        inp.dispatchEvent(new Event('input', {bubbles:true}));
      } catch (e) {}
    }
    r.querySelectorAll('[data-k-qty]').forEach(function(el){
      el.classList.toggle('active', parseInt(el.getAttribute('data-k-qty'), 10) === q);
    });
    if (stickyLabel) stickyLabel.textContent = packLabel(q);
    if (stickyBtn) stickyBtn.textContent = atcLabel(q);
    var addBtn = document.querySelector('#AddToCart, #AddToCart-product-template, [name="add"]');
    if (addBtn && addBtn.tagName === 'BUTTON') {
      var span = addBtn.querySelector('span');
      if (span) span.textContent = atcLabel(q);
      else if (!addBtn.querySelector('svg')) addBtn.textContent = atcLabel(q);
    }
  }

  function readKQty(){
    try {
      var m = /(?:\?|&)k_qty=(\d+)/.exec(window.location.search || '');
      if (m) {
        var q = parseInt(m[1], 10);
        if (q === 1 || q === 3 || q === 5) return q;
      }
    } catch (e) {}
    return null;
  }

  if (onSingle) {
    r.querySelectorAll('[data-k-qty]').forEach(function(el){
      el.addEventListener('click', function(ev){
        ev.preventDefault();
        setQty(parseInt(el.getAttribute('data-k-qty'), 10) || 1);
      });
    });
    var fromUrl = readKQty();
    setQty(fromUrl || 1);

    var form = document.querySelector('#AddToCartForm, form[action*="/cart/add"], #ProductSection form');
    if (form) {
      form.addEventListener('submit', function(){
        setQty(selectedQty);
      }, true);
      var nativeAtc = form.querySelector('#AddToCart, #AddToCart-product-template, [name="add"], button[type="submit"]');
      if (nativeAtc) {
        nativeAtc.addEventListener('click', function(){
          setQty(selectedQty);
        }, true);
      }
    }
  } else if (stickyLabel) {
    var sz = r.getAttribute('data-k-pack-size');
    stickyLabel.textContent = packLabel(parseInt(sz, 10) || 1);
  }

  if (stickyBtn) stickyBtn.addEventListener('click', function(){
    if (onSingle) setQty(selectedQty);
    var add = document.querySelector('#AddToCart,[name="add"],button[type="submit"]');
    if (add) add.click();
    else {
      var p = document.querySelector('#ProductSection');
      if (p) p.scrollIntoView({behavior:'smooth'});
    }
  });
})();
